<template>
  <rest-page ref="restPage" :fetch-endpoint="endpoints">
    <page-header-new :title="pageTitle" :breadcrumbs="breadcrumbs" />
    <page-content>
      <xp-feature-flags v-model="xpFeatureFlags" @save="onXpSave" />
      <mxa-feature-flags />
    </page-content>
  </rest-page>
</template>

<script>
import RestPage from '@/common/components/rest/RestPage'
import PageHeaderNew from '@/common/components/page/PageHeaderNew'
import PageContent from '@/common/components/page/PageContent'
import XpFeatureFlags from '@/modules/project/components/XpFeatureFlags'
import { projectEndpoint } from '@/core/helpers'
import MxaFeatureFlags from '@/modules/project/components/MxaFeatureFlags.vue'

export default {
  name: 'ProjectFeaturesPage',
  components: {
    MxaFeatureFlags,
    PageContent,
    PageHeaderNew,
    RestPage,
    XpFeatureFlags
  },

  data() {
    return {
      breadcrumbs: [
        { label: this.$t('Settings_Breadcrumb_Settings') },
        { label: this.$t('LeftNavigation_ProjectFeatures') }
      ],
      xpFeatureFlags: {},
      mxaFeatureFlags: {}
    }
  },

  computed: {
    pageTitle() {
      return (
        this.$store.getters.embeddedTitle || this.$t(this.$route.meta.title)
      )
    },
    endpoints() {
      return projectEndpoint({
        method: 'get',
        url: '',
        handler: data => {
          this.xpFeatureFlags = data
        }
      })
    }
  },
  methods: {
    onXpSave() {
      this.$router.go()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/project/pages/ProjectFeaturesPage.vue